<template>
  <div id="app">
    <Header ref="header" />
    <transition mode="out-in">
      <router-view ref="routerView" @loginSuccess="loginSuccess" :key="$route.fullPath" />
    </transition>
    <Footer />
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
  components: {
    Header,
    Footer,
  },
  computed: {},
  watch: {
    $route() {
      window.scrollTo(0, 0);
    },
  },
  mounted() {
    document.addEventListener("gesturestart", function (event) {
      event.preventDefault();
    });
    this.$BaaS.init("5c45ce0fd2b57e81dd7a");
    if (!location.href.includes("/wallpaper/square")) {
      setTimeout(() => {
        this.$method.loginWithWechat();
      }, 300);
    }
  },
  methods: {
    loginSuccess() {},
  },
};
</script>
<style lang="less">
@import "./assets/custom.less";
html,
body {
  background: #f9f9f9 !important;
  font-size: 16px;
  margin: 0;
  padding: 0;
  // scroll-behavior: smooth;
  overscroll-behavior: none; //这个阻止下拉刷新
}
:root {
  --color-primary: #141414;
  --color-success: #c7ff4a;
  --color-warning: #e6b060;
  --color-danger: #ee8686;
}
#app {
  font-family: "SourceHanSansCN-Light", "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  padding-top: 0;
}
* {
  transition-property: color, background-color, border, opacity, transform;
  transition-duration: 0.3s;
  transition-timing-function: ease;
  position: relative;
  box-sizing: border-box;
}
@font-face {
  font-family: "BaiJamjuree";
  src: url("https://file2.dreamrail.cn/resources/BaiJamjuree-Bold.ttf");
  font-style: normal;
}
@font-face {
  font-family: "PublicSans";
  src: url("https://file2.dreamrail.cn/resources/PublicSans-SemiBold.ttf");
  font-style: normal;
}
@font-face {
  font-family: "SourceHanSansCN";
  src: url("https://resources.photohelper.cn/resources/SourceHanSansCN-Light.otf") format("opentype");
  font-weight: 100;
  font-style: normal;
}
@font-face {
  font-family: "SourceHanSansCN";
  src: url("https://file2.dreamrail.cn/resources/SourceHanSansCN-Regular.otf") format("opentype");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "SourceHanSansCN";
  src: url("https://file2.dreamrail.cn/resources/SourceHanSansCN-Medium.otf") format("opentype");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: "SourceHanSansCN";
  src: url("https://file2.dreamrail.cn/resources/SourceHanSansCN-Bold.otf") format("opentype");
  font-weight: 700;
  font-style: normal;
}
//图片懒加载相关
img[lazy] {
  transition-duration: 1s;
}
img[lazy="loading"] {
  opacity: 0;
}
img[lazy="loaded"] {
  opacity: 1 !important;
}
.dreamrail-message {
  padding: 0 24px !important;
  height: 74px;
  background: #d8bc6b !important;
  backdrop-filter: blur(5px);
  border-radius: 37px !important;
  border: none !important;
  min-width: 300px !important;
  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.05);
  .el-message__content {
    color: #fff !important;
    font-weight: 500;
    font-size: 16px;
    line-height: 25px;
    text-align: left;
    margin-left: 12px;
    text-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    a {
      color: #fff !important;
    }
  }
  .dreamrail-message-icon {
    width: 50px;
    height: 50px;
    background: url(https://file2.dreamrail.cn/resources/message-problem2.png) no-repeat center;
    background-size: cover;
    flex-shrink: 0;
  }
  &.dreamrail-message-warning {
    background: #1ac500 !important;
  }
  &.dreamrail-message-success {
    background: #ffb700 !important;
    .dreamrail-message-icon {
      background: url(https://file2.dreamrail.cn/resources/message-OK2.png) no-repeat center;
      background-size: cover;
    }
  }
}
//解决el-select在ios双击才能选中的问题
.el-scrollbar {
  .el-scrollbar__bar {
    opacity: 1 !important;
  }
}
//解决$message在移动端跑到页面顶上去的问题
.el-message-box {
  background: #000;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  @media screen and (max-width: 768px) {
    width: 90% !important;
  }
}
//dialog爆框问题
.el-dialog {
  max-width: 90vw;
}
.el-button {
  &.el-button--primary {
    &.is-plain {
      &:hover {
        background: #d3d6db;
        color: var(--color-primary);
      }
    }
  }
}
</style>
